import { makeStyles } from '@material-ui/core';

export const contratoTableStyles = makeStyles({
  situacaoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  badge: {
    color: '#ffffff',
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: 10,
    fontWeight: 600,
    borderRadius: '0px !important',
    width: '35%',
    textAlign: 'center',
    margin: 'auto',
  },
  badgeAtivo: {
    backgroundColor: '#2DC44D',
  },
  badgeEncerrado: {
    backgroundColor: '#3286A8',
  },
  badgeRescindido: {
    backgroundColor: '#B53838',
  },
});
